// Fire-and-forget event tracker. Posts to /api/v1/track on production,
// logs to console on localhost / preview deploys so dev sessions don't
// pollute real analytics.

const API_BASE = (import.meta.env.VITE_API_BASE as string) ?? '';
const PROD_HOST = 'stelsearch.pages.dev';

export type EventName =
  | 'search-submitted'
  | 'filter-changed'
  | 'video-click'
  | 'random-pick'
  | 'load-more';

type EventData = Record<string, string | number | boolean>;

function isProd() {
  return typeof window !== 'undefined' && window.location.hostname === PROD_HOST;
}

export function track(name: EventName, data?: EventData): void {
  if (typeof window === 'undefined') return;

  if (!isProd()) {
    // Visible in browser devtools so you can verify locally.
    console.debug('[track:dev]', name, data ?? {});
    return;
  }

  const url = `${API_BASE}/track`;
  const payload = JSON.stringify({ name, ...(data ? { data } : {}) });

  // Prefer sendBeacon — survives navigation (essential for video-click).
  if (navigator.sendBeacon) {
    try {
      const blob = new Blob([payload], { type: 'application/json' });
      if (navigator.sendBeacon(url, blob)) return;
    } catch {}
  }
  // Fallback: keepalive fetch.
  void fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  }).catch(() => {});
}
